import React, { useState } from 'react';
import { ImagePlus, X, Loader2 } from 'lucide-react';
import { uploadImage } from '../../services/apiClient';

// Mission "Product Experience V1" / section 4: remplace le champ brut
// "Logo (URL)" par un vrai téléversement (aperçu / remplacer / retirer), en
// réutilisant l'unique point d'upload Cloudinary déjà exposé côté serveur
// (POST /media/profile-image). Si l'upload échoue (Cloudinary non configuré
// côté serveur, 503), on affiche un message clair plutôt que de retomber
// sur un champ URL brut — voir section 4: "prefer no logo field over a
// broken URL field."
export default function ImageUploadField({ label, value, onChange, disabled, circular }) {
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState('');

  const handleFile = async (event) => {
    const file = event.target.files?.[0];
    event.target.value = '';
    if (!file) return;
    if (!String(file.type || '').startsWith('image/')) {
      setError('Veuillez sélectionner une image valide.');
      return;
    }
    setError('');
    setUploading(true);
    try {
      const { url } = await uploadImage(file);
      onChange(url || '');
    } catch (err) {
      setError(err?.status === 503
        ? "Téléversement d'image indisponible pour le moment."
        : (err?.message || 'Téléversement impossible.'));
    } finally {
      setUploading(false);
    }
  };

  return (
    <div>
      {label && <span style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#475569', marginBottom: 6 }}>{label}</span>}
      <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
        {value && (
          <div style={{ position: 'relative' }}>
            <img src={value} alt="" style={{ width: 56, height: 56, borderRadius: circular ? '50%' : 12, objectFit: 'cover', background: '#EEF4EE', border: '1px solid #e2e8f0' }} />
            <button
              type="button"
              onClick={() => onChange('')}
              disabled={disabled || uploading}
              aria-label="Retirer l'image"
              style={{ position: 'absolute', top: -8, right: -8, width: 22, height: 22, borderRadius: 11, border: 'none', background: '#ef4444', color: 'white', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
            >
              <X size={13} />
            </button>
          </div>
        )}
        <label style={{
          display: 'inline-flex', alignItems: 'center', gap: 8, cursor: disabled || uploading ? 'not-allowed' : 'pointer',
          padding: '9px 14px', borderRadius: 10, border: '1px solid #cbd5e1', background: 'white', color: '#334155', fontWeight: 600, fontSize: 13
        }}>
          {uploading ? <Loader2 size={15} aria-hidden="true" style={{ animation: 'nsara-spin 0.7s linear infinite' }} /> : <ImagePlus size={15} aria-hidden="true" />}
          {uploading ? 'Téléversement…' : value ? 'Remplacer' : 'Choisir une image'}
          <input type="file" accept="image/*" onChange={handleFile} disabled={disabled || uploading} style={{ display: 'none' }} />
        </label>
      </div>
      {error && <p role="alert" style={{ margin: '6px 0 0', color: '#b91c1c', fontSize: 12 }}>{error}</p>}
    </div>
  );
}
